import { render, staticRenderFns } from "./SongsSearchInput.vue?vue&type=template&id=3074b21b&scoped=true&"
import script from "./SongsSearchInput.vue?vue&type=script&lang=js&"
export * from "./SongsSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./SongsSearchInput.vue?vue&type=style&index=0&id=3074b21b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3074b21b",
  null
  
)

export default component.exports